"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildProgramCurriculumRefined = exports.buildProgramRefined = void 0;
const __1 = require("..");
const buildProgramRefined = (program) => ({
    ID: program.ID,
    metadata: {
        created: program.metadata.created,
        updated: program.metadata.updated,
    },
    code: program.code,
    name: program.name,
    course: program.course,
    primaryAccess: program.primaryAccess,
    chairs: program.chairs,
    customAttributes: program.customAttributes,
});
exports.buildProgramRefined = buildProgramRefined;
const buildProgramCurriculumRefined = (program, deliveries, subjectPrograms) => ({
    ID: program.ID,
    metadata: {
        created: program.metadata.created,
        updated: program.metadata.updated,
    },
    code: program.code,
    name: program.name,
    course: program.course,
    primaryAccess: program.primaryAccess,
    accessIDs: subjectPrograms.reduce((list, subjectProgram) => list.indexOf(subjectProgram.subject.access.ID) >= 0 ? list : [...list, subjectProgram.subject.access.ID], []),
    chairs: program.chairs,
    deliveries: deliveries.map(__1.buildDeliveryRefined),
    subjects: subjectPrograms.map((subjectProgram) => ({
        ...subjectProgram.subject,
        type: subjectProgram.type,
    })),
    customAttributes: program.customAttributes,
});
exports.buildProgramCurriculumRefined = buildProgramCurriculumRefined;
//# sourceMappingURL=ProgramRefined.js.map